import {Component, OnInit} from '@angular/core';
import {
  NotificationDialogComponent
} from "../../../../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../../../../../../shared/utils/text-utils";
import {DialogService} from "../../../../../../../ng2-bootstrap-modal/dialog.service";
import {DbResponse} from "../../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {CloudflareService} from "../../../services/cloudflare.service";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-cdn-clear-cache',
    templateUrl: './cdn-clear-cache.component.html',
    styleUrls: ['./cdn-clear-cache.component.scss'],
    standalone: false
})
export class CdnClearCacheComponent implements OnInit {

  public websiteId: number;
  public loading: boolean;

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _cloudflareService: CloudflareService,
    private readonly _route: ActivatedRoute,
    private  _googleAnalyticsService: GoogleAnalyticsService,
    ) {}

  ngOnInit() {
    this.websiteId = +this._route.snapshot.parent.parent.params['id'];
  }

  public openClearCacheDialog(): void {
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_clearCloudflareCache'),
      message: TextUtils.getText('text_clearCloudflareCacheDesc'),
      buttonText: TextUtils.getText('text_clearCacheBtnDialog'),
      buttonColor: 'red',
      action: 'clear-cdn-cache',
      showCancelButton: true,
      hasCloseButton: true
    })
      .subscribe((confirmed: string): void => {
        if (confirmed && confirmed === 'clear-cdn-cache') {
            this._purgeCache();
        }
      });
  }

  private _purgeCache(): void {
    this.loading = true;
    this._cloudflareService.purgeCache(this.websiteId)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          this.sendEvent();
          NotifierComponent.notify(new Notification('Cloudflare cache entirely cleared', NotificationType.SUCCESS));
        }
        else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }
      });
  }

  public sendEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Clear cache',
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
